module.exports = __webpack_public_path__ + "assets/images/branch/main-bg.jpg";